import { generateToken } from '../../utils/sec';
import store from '../../store';
import { isMobile } from '../../utils';
import { TOGGLE_FULLSCREEN } from '../user';


export const API_TOKEN = `Bearer ${generateToken()}`;
export const fetch_options: any = {
  headers: {
    Authorization: API_TOKEN,
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
  }
};

export const shouldReloadElements = (lastUpdate, timeToReload) => {
  const now = Date.now();

  if (!lastUpdate) return true;
  else if (now - lastUpdate >= timeToReload) return true;
  else return false;
}

export const loadStoredDate = (itemName, processFunc) => {
  if (!itemName) return null;
  const itemsStr = localStorage.getItem(itemName);
  if (itemsStr) {
    const items = JSON.parse(itemsStr);
    if (items) {
      try {
        const procItems = processFunc ? processFunc(items) : items;
        return procItems;
      } catch (error) {
        return null;
      }

    } else return null;
  } else {
    return null;
  }
}

export const openFullscreen = () => {
  const elem = document.documentElement;

  if (elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE11 */
      elem.msRequestFullscreen();
    }

    store.dispatch({
      type: TOGGLE_FULLSCREEN,
      full_screen: true
    });
  }
}

export const closeFullscreen = () => {
  const elem = document.documentElement;

  if (elem) {
    if (document.fullscreenElement !== null) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
      }
    }

    store.dispatch({
      type: TOGGLE_FULLSCREEN,
      full_screen: false
    });
  }
}

export const switchToFullscreen = () => {
  if (isMobile() && !window.cordova) openFullscreen();
}

export const quitFromFullscreen = () => {
  if (isMobile() && !window.cordova) closeFullscreen();
}